import { render, staticRenderFns } from "./MicrosoftTeams.vue?vue&type=template&id=743c208a&"
import script from "./MicrosoftTeams.vue?vue&type=script&lang=js&"
export * from "./MicrosoftTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports